import { IGachNoRequest } from "../../../model/request/dong-bo/IGachNoRequest";
import { IGachNoThuCongActionTypes } from "../../action-types/dong-bo/IGachNoThuCongAction";
import { IGachNoThuCongReducer } from "../../reducer-model/dong-bo/IGachNoThuCongReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IGachNoResponse } from "./../../../model/respone/dong-bo/IGachNoResponse";

const iniState: IGachNoThuCongReducer = {
  status: eReducerStatusBase.is_not_initialization,
  request: {
    code_bank: "",
    entries: [],
  } as IGachNoRequest,
  result: {} as IGachNoResponse,
  step: 0,
} as IGachNoThuCongReducer;

export const gachNoThuCongReducer = (
  state: IGachNoThuCongReducer = iniState,
  action: IGachNoThuCongActionTypes,
): IGachNoThuCongReducer => {
  switch (action.type) {
    case "GACH_NO_THU_CONG_GACH_NO_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "GACH_NO_THU_CONG_GACH_NO_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        step: 2,
        result: action.payload,
      };
    case "GACH_NO_THU_CONG_GACH_NO_ERR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "GACH_NO_THU_CONG_CHANGE_REQUEST":
      return {
        ...state,
        request: {
          ...state.request,
          ...action.payload,
        },
      };
    case "GACH_NO_THU_CONG_CHANGE_STEP":
      return {
        ...state,
        step: action.payload,
      };
    case "GACH_NO_THU_CONG_SELECTED_NGAN_HANG":
      return {
        ...state,
        request: {
          ...state.request,
          code_bank: action.payload,
        },
      };
    case "GACH_NO_THU_CONG_RESET_RESULT":
      return {
        ...state,
        result: {} as IGachNoResponse,
      };

    default:
      return state;
  }
};
